import './changsha/style';
import FormStructure from './changsha/form_structure';

export default FormStructure;